import { FilterDefinition } from './filters.model'

/**
 * A suggested filter fragment that can be applied to a draft or existing filter.
 */
export class FilterSuggestion {
  id: string
  title: string
  prompt: string
  filterQuery: string
  filterDefinition: FilterDefinition

  /**
   * Creates a hydrated filter suggestion model.
   * @param {Partial<FilterSuggestion>} suggestion - The raw API suggestion.
   */
  constructor(suggestion: Partial<FilterSuggestion>) {
    Object.assign(this, suggestion)

    if (this.filterDefinition) {
      this.filterDefinition = new FilterDefinition(this.filterDefinition)
    }
  }
}
